module.exports = `<!DOCTYPE html>
<html>
<title>Trojan Energy Limited - Document Portal</title>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<link rel="stylesheet" href="https://www.w3schools.com/w3css/4/w3.css">
<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Raleway">
<script src="https://kit.fontawesome.com/0ee23d3d9a.js" crossorigin="anonymous"></script>
<script type="text/javascript">
    function collapseContainer(id) {
        const elements = document.getElementById(id).children;
        for (let i=0;i<elements.length;i++) {
            if (elements.item(i).style.display === "table-row") {
                elements.item(i).style.display = "none";
            }
            else {
                elements.item(i).style.display = "table-row";
            }
        }
    }
</script>
<style>
html,body,h1,h2,h3,h4,h5 {font-family: "Raleway", sans-serif}
  .container {
    display: table;
  }

  .row  {
    display: none;
  }

  .left, .right, .middle {
    display: table-cell;
    padding: 10px;
  }

  .location {
    width: 100%;
  }
</style>
<body class="w3-light-grey">

<!-- Top container -->
<div class="w3-bar w3-top w3-black w3-large" style="z-index:4">
  <button class="w3-bar-item w3-button w3-hide-large w3-hover-none w3-hover-text-light-grey" onclick="w3_open();"><i class="fa fa-bars"></i>  Menu</button>
  <span class="w3-bar-item w3-left"><img src="images/Trojan_Logo.png" alt="Trojan Energy Limited" height="50px"></img></span>
  <h2>Technical</h2>
</div>

<!-- Sidebar/menu -->
<nav class="w3-sidebar w3-collapse w3-white w3-animate-left" style="z-index:3;width:300px;" id="mySidebar"><br>
  <div class="w3-container w3-row">
    <br />
    <div class="w3-col s4">
      <img src="images/avatars/avatar2.png" class="w3-circle w3-margin-right" style="width:46px">
    </div>
    <div class="w3-col s8 w3-bar">
      <span>Welcome, <strong>Marsha</strong></span><br>
      <a href="#" class="w3-bar-item w3-button"><i class="fa fa-envelope"></i></a>
      <a href="#" class="w3-bar-item w3-button"><i class="fa fa-user"></i></a>
      <a href="#" class="w3-bar-item w3-button"><i class="fa fa-cog"></i></a>
    </div>
  </div>
  <hr>
  <div class="w3-container">
    <h5>Actions</h5>
  </div>
  <div class="w3-container">
    Search By
    <div class="w3-bar-block">
        <a href="#" class="w3-bar-item w3-button w3-padding-16 w3-hide-large w3-dark-grey w3-hover-black" onclick="w3_close()" title="close menu"><i class="fa fa-remove fa-fw"></i>  Close Menu</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  SDRL Code</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  System Hierarchy</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Model Number</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Serial Number</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Discipline</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Location</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Author</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Client</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Project</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Workscope</a><br><br>
    </div>
  </div>
  <div class="w3-container">
    Document Management
    <div class="w3-bar-block">
        <a href="#" class="w3-bar-item w3-button w3-padding-16 w3-hide-large w3-dark-grey w3-hover-black" onclick="w3_close()" title="close menu"><i class="fa fa-remove fa-fw"></i>  Close Menu</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Create Document Number</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Upload Document</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Workflow Document</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Create Transmittal</a>
    </div>
  </div>
</nav>

<!-- Overlay effect when opening sidebar on small screens -->
<div class="w3-overlay w3-hide-large w3-animate-opacity" onclick="w3_close()" style="cursor:pointer" title="close side menu" id="myOverlay"></div>

<!-- !PAGE CONTENT! -->
<div class="w3-main" style="margin-left:300px;margin-top:43px;">

  <!-- Header -->
  <header class="w3-container" style="padding-top:22px">
    <a href="doc_controller" style="text-decoration:none;"><h5><b><i class="fa fa-toggle-left"></i> Doc Controller</b></h5></a>
  </header>

  <div class="w3-row-padding w3-margin-bottom">
    <div>
      <div class="w3-container w3-orange w3-padding-16">
        <div class="w3-left"><i class="fa fa-scale-balanced w3-xxxlarge"></i></div>
        <div class="w3-right">
          <h3>35</h3>
        </div>
        <div class="w3-clear"></div>
        <h4>Technical</h4>
      </div>
    </div>
  </div>

  <div class="w3-third" style="padding:20px">
    <div class="w3-row-padding" style="margin:0 -16px">
      <h4><b>STEP Locations</b></h4>
      <button class="location" id="WilloughbyBtn" width="100%" onclick="collapseContainer('WilloughbyCont');"><h5> Willoughby Road</h5></button>
      <div class="container" id="WilloughbyCont">
        <div class="row">
            <a href="technical/L0002-Willoughby/L0002_001_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0002-001</div>
            <div class="left">Willoughby Road L0002 Above Ground Plan</div>
            <div class="middle">X1</div>
            </a>
        </div>
        <div class="row">
            <a href="technical/L0002-Willoughby/L0002_002_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0002-002</div>
            <div class="left">Willoughby Road L0002 Below Ground Plan</div>
            <div class="middle">X1</div>
            </a>
        </div>
        <div class="row">
            <a href="technical/L0002-Willoughby/L0002_003_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0002-003</div>
            <div class="left">Willoughby Road L0002 Charger &amp; Cabinet Details</div>
            <div class="middle">X1</div>
            </a>
        </div>
      </div>
      <button class="location" id="GoldhurstBtn" width="100%" onclick="collapseContainer('GoldhurstCont');"><h5> Goldhurst Road</h5></button>
      <div class="container" id="GoldhurstCont">
      </div>
      <button class="location" id="WillowBtn" width="100%" onclick="collapseContainer('WillowCont');"><h5> Willow Road</h5></button>
      <div class="container" id="WillowCont">
        <div class="row">
            <a href="technical/L0004-Willow/L0004_001_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0004-001</div>
            <div class="left">Willow Road L0004 Above Ground Plan<br /></div>
            <div class="middle">X1</div>
            </a>
        </div>
        <div class="row">
            <a href="technical/L0004-Willow/L0004_002_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0004-002</div>
            <div class="left">Willow Road L0004 Below Ground Plan<br /></div>
            <div class="middle">X1</div>
            </a>
        </div>
        <div class="row">
            <a href="technical/L0004-Willow/L0004_003_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0004-003</div>
            <div class="left">Willow Road L0004 Charger &amp; Cabinet Details<br /></div>
            <div class="middle">X1</div>
            </a>
        </div>
        <div class="row">
            <a href="technical/L0004-Willow/L0004_004_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0004-004</div>
            <div class="left">Willow Road L0004 Below Ground Plan - Option 2</div>
            <div class="middle">X1</div>
            </a>
        </div>
      </div>
      <button class="location" id="ParliamentBtn" width="100%" onclick="collapseContainer('ParliamentCont');"><h5> Parliament Hill</h5></button>
      <div class="container" id="ParliamentCont">
        <div class="row">
            <a href="technical/L0005-Parliament/L0005_001_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0005-001</div>
            <div class="left">Parliament Hill L0005 Above Ground Plan<br /></div>
            <div class="middle">X1</div>
            </a>
        </div>
        <div class="row">
            <a href="technical/L0005-Parliament/L0005_002_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0005-002</div>
            <div class="left">Parliament Hill L0005 Below Ground Plan<br /></div>
            <div class="middle">X1</div>
            </a>
        </div>
        <div class="row">
            <a href="technical/L0005-Parliament/L0005_003_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0005-003</div>
            <div class="left">Parliament Hill L0005 Charger &amp; Cabinet Details<br /></div>
            <div class="middle">X1</div>
            </a>
        </div>
      </div>
      <button class="location" id="MiltonBtn" width="100%" onclick="collapseContainer('MiltonCont');"><h5> Milton Avenue</h5></button>
      <div class="container" id="MiltonCont">
        <div class="row">
            <a href="technical/L0012-Milton/L0012_001_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0012-001</div>
            <div class="left">Milton Avenue L0012 Grid Map, Key Plan &amp; Installation Plan<br /></div>
            <div class="middle">X1</div>
            </a>
        </div>
        <div class="row">
            <a href="technical/L0012-Milton/L0012_002_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0012-002</div>
            <div class="left">Milton Avenue L0012 Plan &amp; Section Installation Details<br /></div>
            <div class="middle">X1</div>
            </a>
        </div>
        <div class="row">
            <a href="technical/L0012-Milton/L0012_003_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0012-003</div>
            <div class="left">Milton Avenue L0012 Street Elevation Details<br /></div>
            <div class="middle">X1</div>
            </a>
        </div>
        <div class="row">
            <a href="technical/L0012-Milton/L0012_004_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0012-004</div>
            <div class="left">Milton Avenue L0012 Street Elevation Details</div>
            <div class="middle">X1</div>
            </a>
        </div>
      </div>
    </div>
    <div class="w3-row-padding" style="margin:0 -16px">
      <h4><b>SmartSTEP Locations</b></h4>
      <button class="location" id="MortimerBtn" width="100%" onclick="collapseContainer('MortimerCont');"><h5>Mortimer Road As</h5></button>
      <div class="container" id="MortimerCont">
        <div class="row">
            <a href="technical/L0006-Mortimer/L0006_001_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0006-001</div>
            <div class="left">Mortimer Road L0006 Grid Map, Key Plan &amp; Installation Plan<br /></div>
            <div class="middle">X1</div>
            </a>
        </div>
        <div class="row">
            <a href="technical/L0006-Mortimer/L0006_002_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0006-002</div>
            <div class="left">Mortimer Road L0006 Plan &amp; Section Installation Details<br /></div>
            <div class="middle">X1</div>
            </a>
        </div>
        <div class="row">
            <a href="technical/L0006-Mortimer/L0006_003_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0006-003</div>
            <div class="left">Mortimer Road L0006 Street Elevation Details<br /></div>
            <div class="middle">X1</div>
            </a>
        </div>
        <div class="row">
            <a href="technical/L0006-Mortimer/L0006_004_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0006-004</div>
            <div class="left">Mortimer Road L0006 Street Elevation Details</div>
            <div class="middle">X1</div>
            </a>
        </div>
        <div class="row">
            <a href="technical/L0006-Mortimer/L0006_005_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0006-005</div>
            <div class="left">Mortimer Road L0006 Street Elevation Details</div>
            <div class="middle">X1</div>
            </a>
        </div>
      </div>
      <button class="location" id="PurvesBtn" width="100%" onclick="collapseContainer('PurvesCont');"><h5>Purves Road</h5></button>
      <div class="container" id="PurvesCont">
        <div class="row">
            <a href="technical/L0007-Purves/L0007_001_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0007-001</div>
            <div class="left">Purves Road L0007 Grid Map, Key Plan &amp; Installation Plan<br /></div>
            <div class="middle">X1</div>
            </a>
        </div>
        <div class="row">
            <a href="technical/L0007-Purves/L0007_002_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0007-002</div>
            <div class="left">Purves Road L0007 Plan &amp; Section Installation Details<br /></div>
            <div class="middle">X1</div>
            </a>
        </div>
        <div class="row">
            <a href="technical/L0007-Purves/L0007_003_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0007-003</div>
            <div class="left">Purves Road L0007 Plan &amp; Section Installation Details<br /></div>
            <div class="middle">X1</div>
            </a>
        </div>
        <div class="row">
            <a href="technical/L0007-Purves/L0007_004_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0007-004</div>
            <div class="left">Purves Road L0007 Plan &amp; Section Installation Details</div>
            <div class="middle">X1</div>
            </a>
        </div>
        <div class="row">
            <a href="technical/L0007-Purves/L0007_005_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0007-005</div>
            <div class="left">Purves Road L0007 Street Elevation Details</div>
            <div class="middle">X1</div>
            </a>
        </div>
      </div>
      <button class="location" id="StMargaretsBtn" width="100%" onclick="collapseContainer('StMargaretsCont');"><h5> St Margarets Road</h5></button>
      <div class="container" id="StMargaretsCont">
        <div class="row">
            <a href="technical/L0008-StMargarets/L0008_001_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0008-001</div>
            <div class="left">St Margarets Road L0008 Grid Map, Key Plan &amp; Installation Plan<br /></div>
            <div class="middle">X1</div>
            </a>
        </div>
        <div class="row">
            <a href="technical/L0008-StMargarets/L0008_002_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0008-002</div>
            <div class="left">St Margarets Road L0008 Plan &amp; Section Installation Details<br /></div>
            <div class="middle">X1</div>
            </a>
        </div>
        <div class="row">
            <a href="technical/L0008-StMargarets/L0008_003_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0008-003</div>
            <div class="left">St Margarets Road L0004 Street Elevation Details<br /></div>
            <div class="middle">X1</div>
            </a>
        </div>
      </div>
      <button class="location" id="EarlsmeadBtn" width="100%" onclick="collapseContainer('EarlsmeadCont');"><h5> Earlesmead Road</h5></button>
      <div class="container" id="EarlsmeadCont">
        <div class="row">
            <a href="technical/L0009-Earlsmead/L0009_001_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0009-001</div>
            <div class="left">Earlsmead Road L0009 Grid Map, Key Plan &amp; Installation Plan<br /></div>
            <div class="middle">X1</div>
            </a>
        </div>
        <div class="row">
            <a href="technical/L0009-Earlsmead/L0009_002_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0009-002</div>
            <div class="left">Earlsmead Road L0009 Plan &amp; Section Installation Details<br /></div>
            <div class="middle">X1</div>
            </a>
        </div>
        <div class="row">
            <a href="technical/L0009-Earlsmead/L0009_003_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0009-003</div>
            <div class="left">Earlsmead Road L0009 Street Elevation Details<br /></div>
            <div class="middle">X1</div>
            </a>
        </div>
        <div class="row">
            <a href="technical/L0009-Earlsmead/L0009_004_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0009-004</div>
            <div class="left">Earlsmead Road L0009 Street Elevation Details<br /></div>
            <div class="middle">X1</div>
            </a>
        </div>
      </div>
      <button class="location" id="ShakespeareBtn" width="100%" onclick="collapseContainer('ShakespeareCont');"><h5> Shakespeare Road</h5></button>
      <div class="container" id="ShakespeareCont">
        <div class="row">
            <a href="technical/L0011-Shakespeare/L0011_001_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0011-001</div>
            <div class="left">Shakespeare Road L0011 Grid Map, Key Plan &amp; Installation Plan<br /></div>
            <div class="middle">X1</div>
            </a>
        </div>
        <div class="row">
            <a href="technical/L0011-Shakespeare/L0011_002_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0011-002</div>
            <div class="left">Shakespeare Road L0011 Plan &amp; Section Installation Details<br /></div>
            <div class="middle">X1</div>
            </a>
        </div>
        <div class="row">
            <a href="technical/L0011-Shakespeare/L0011_003_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0011-003</div>
            <div class="left">Shakespeare Road L0011 Street Elevation Details<br /></div>
            <div class="middle">X1</div>
            </a>
        </div>
        <div class="row">
            <a href="technical/L0011-Shakespeare/L0011_004_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0011-004</div>
            <div class="left">Shakespeare Road L0011 Street Elevation Details<br /></div>
            <div class="middle">X1</div>
            </a>
        </div>
        <div class="row">
            <a href="technical/L0011-Shakespeare/L0011_005_X1.pdf" target="previewer" style="text-decoration:none;">
            <div class="middle"><i class="fa fa-circle-check w3-text-green w3-large"></i></div>
            <div class="left">L0011-005</div>
            <div class="left">Shakespeare Road L0011 Street Elevation Details<br /></div>
            <div class="middle">X1</div>
            </a>
        </div>
      </div>
    </div>
  </div>
  <iframe name="previewer" src="" class="w3-twothird" height="1000px" frameBorder="0"></iframe>
  <hr />
  <hr />
  <br>
  <!--
  <div class="w3-container w3-dark-grey w3-padding-32">
    <div class="w3-row">
      <div class="w3-container w3-third">
        <h5 class="w3-bottombar w3-border-red">To Action</h5>
        <p>Rejected Workflows</p>
        <p>Review Overdue</p>
        <p></p>
      </div>
      <div class="w3-container w3-third">
        <h5 class="w3-bottombar w3-border-orange">In-Progress</h5>
        <p>Unreleased Documents</p>
        <p>Workflow Comments</p>
        <p>Review Ongoing</p>
      </div>
      <div class="w3-container w3-third">
        <h5 class="w3-bottombar w3-border-green">Completed</h5>
        <p>Document Releases</p>
        <p>Transmittals</p>
        <p>Review Cycles /  Approvals</p>
      </div>
    </div>
  </div> -->

  <!-- Footer -->
  <footer class="w3-container w3-padding-16 w3-light-grey">
    <h4>TROJAN ENERGY LIMITED, 2022</h4>
    <p>Powered by <a href="https://www.w3schools.com/w3css/default.asp" target="_blank">w3.css</a></p>
  </footer>

  <!-- End page content -->
</div>

<script>
// Get the Sidebar
var mySidebar = document.getElementById("mySidebar");

// Get the DIV with overlay effect
var overlayBg = document.getElementById("myOverlay");

// Toggle between showing and hiding the sidebar, and add overlay effect
function w3_open() {
  if (mySidebar.style.display === 'block') {
    mySidebar.style.display = 'none';
    overlayBg.style.display = "none";
  } else {
    mySidebar.style.display = 'block';
    overlayBg.style.display = "block";
  }
}

// Close the sidebar with the close button
function w3_close() {
  mySidebar.style.display = "none";
  overlayBg.style.display = "none";
}

</script>

</body>
</html>`;
